// extracted by mini-css-extract-plugin
export default {"borderContainer":"styles_borderContainer__eramb","container":"styles_container__ZDBDV","consText":"styles_consText__5cNds","checkIcon":"styles_checkIcon__VPFG+"};